export const libBerechneDatumVolljaehrigAb = () => {
    let heute = new Date();
    heute.setFullYear(heute.getFullYear()-18);
    return heute;
}

export const libBerechneDatumVolljaehrigAbIsoStr = () => libBerechneDatumVolljaehrigAb().toISOString().substring(0,10);

export const libInEuroAnzeigen = (geldbetrag: number) => {
    return new Intl.NumberFormat('de-DE',
        { style: 'currency', currency: 'EUR' }
    ).format(geldbetrag);
}
